import { HDSIcon } from '@here/hds-react-components'
import React, { CSSProperties, MouseEvent } from 'react'

interface CloseButtonProps {
  onClick: () => void
  style?: CSSProperties
  styleOnHover?: CSSProperties
  styleOnMouseDown?: CSSProperties
}

export default function CloseButton({
  onClick,
  style,
  styleOnHover,
  styleOnMouseDown,
}: CloseButtonProps): JSX.Element {
  const hdsCloseIconStyle = {
    '--hds-icon-color': 'var(--hds-foreground-secondary)',
    'cursor': 'pointer',
    ...style,
  } as React.CSSProperties

  const handleCloseButtonMouseDown = (e: MouseEvent<HTMLElement>): void => {
    const mouseDownDefaultStyle = {
      '--hds-icon-color': 'var(--hds-foreground-primary-press)',
    }
    const style = Object.assign(mouseDownDefaultStyle, styleOnMouseDown) as unknown as {
      [key: string]: string
    }
    Object.keys(style).forEach((key) => {
      ;(e.target as HTMLElement).style.setProperty(key, style[key])
    })
  }
  const handleCloseButtonMouseEnter = (e: MouseEvent<HTMLElement>): void => {
    const hoverDefaultStyle = {
      '--hds-icon-color': 'var(--hds-foreground-primary-hover)',
    }
    const style = Object.assign(hoverDefaultStyle, styleOnHover) as unknown as {
      [key: string]: string
    }
    Object.keys(style).forEach((key) => {
      ;(e.target as HTMLElement).style.setProperty(key, style[key])
    })
  }
  const handleCloseButtonMouseLeave = (e: MouseEvent<HTMLElement>): void => {
    if (style !== undefined && '--hds-icon-color' in style) {
      ;(e.target as HTMLElement).style.setProperty(
        '--hds-icon-color',
        style['--hds-icon-color'] as string
      )
    } else {
      ;(e.target as HTMLElement).style.setProperty(
        '--hds-icon-color',
        'var(--hds-foreground-secondary)'
      )
    }
  }

  return (
    <HDSIcon
      data-testid="close-button"
      name="cross"
      style={hdsCloseIconStyle}
      iconStyle="solid"
      size="24"
      onMouseDown={handleCloseButtonMouseDown}
      onMouseEnter={handleCloseButtonMouseEnter}
      onMouseLeave={handleCloseButtonMouseLeave}
      onClick={onClick}
    />
  )
}
